module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/hairmake_sns_04-9e1f9708beebfc25ee3033146973fe78.jpg";